var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_13777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 5.5C17.8127 5.50248 15.7157 6.37247 14.1691 7.91911C12.6225 9.46575 11.7525 11.5627 11.75 13.75C11.75 20.8094 19.25 26.1437 19.5688 26.3687C19.6965 26.4538 19.8465 26.4992 20 26.4992C20.1535 26.4992 20.3035 26.4538 20.4313 26.3687C20.75 26.1437 28.25 20.8094 28.25 13.75C28.2475 11.5627 27.3775 9.46575 25.8309 7.91911C24.2843 6.37247 22.1873 5.50248 20 5.5ZM20 10.75C20.5933 10.75 21.1734 10.9259 21.6667 11.2556C22.1601 11.5852 22.5446 12.0538 22.7716 12.6019C22.9987 13.1501 23.0581 13.7533 22.9424 14.3353C22.8266 14.9172 22.5409 15.4518 22.1213 15.8713C21.7018 16.2909 21.1672 16.5766 20.5853 16.6924C20.0033 16.8081 19.4001 16.7487 18.8519 16.5216C18.3038 16.2946 17.8352 15.9101 17.5056 15.4167C17.1759 14.9234 17 14.3433 17 13.75C17 12.9543 17.3161 12.1913 17.8787 11.6287C18.4413 11.0661 19.2044 10.75 20 10.75Z",
    fill: "#141046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_13777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoIcon);
export default __webpack_public_path__ + "static/media/geo-icon.771020f8786d39a39d5d9621a76e5d3c.svg";
export { ForwardRef as ReactComponent };